<script>
import { TUTORIAL_TYPES } from '../broadcast/constants/tutorials.constants';
import SMS_AUTOMATION_FTU_SLIDES_ENTRIES from './smsAutomationFtuStateSlideEntries.json';
import { trackSmsFeatureDiscovered } from './smsAnalytics';
import { isSpaApp } from '@/api/shared';

export const SMS_AUTOMATION_FEATURE = 'SMS Automation';
export const SMS_AUTOMATION_FEATURE_TITLE = 'Create and send \n'
            + 'automated text messages';
export const SMS_AUTOMATION_FEATURE_DESCRIPTION = 'Keep your contacts engaged with automated text messages. Build relationships without the manual effort.';
export const SMS_AUTOMATION_FEATURE_CTA = 'Skip the tour';

export default {
    mounted  () {
        const data = isSpaApp();

        trackSmsFeatureDiscovered('Automations Node Selection', data);
    },

    render() {
        return this.$scopedSlots.default({
            feature: SMS_AUTOMATION_FEATURE,
            title: SMS_AUTOMATION_FEATURE_TITLE,
            description: SMS_AUTOMATION_FEATURE_DESCRIPTION,
            cta: SMS_AUTOMATION_FEATURE_CTA,
            tourSlides: SMS_AUTOMATION_FTU_SLIDES_ENTRIES,
            tourKey: TUTORIAL_TYPES.ONBOARDING.TOURS.SMS_AUTOMATION,
        });
    },
};
</script>
